import { render } from "./tab-studies.vue?vue&type=template&id=5ca529d4&scoped=true"
import script from "./tab-studies.vue?vue&type=script&lang=js"
export * from "./tab-studies.vue?vue&type=script&lang=js"

import "./tab-studies.vue?vue&type=style&index=0&id=5ca529d4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca529d4"]])

export default __exports__